/* eslint-disable */
const baseApi = {};
baseApi.baseurl = process.env.REACT_APP_BASE_URL; // backend url
// baseApi.baseurl = "https://server.qodequay.com/okr/dev/api";
// baseApi.baseurl = "http://192.168.2.89:2011/"; // backend url


export default baseApi;
